<label *ngIf="label" [for]="labelId">{{ label }}</label>
<ng-select
  #select
  [labelForId]="labelId"
  [class]="(checkbox ? 'withCheckbox' : 'withoutCheckbox') + ' ' + (darkMode === true ? 'dark' : '') + ' ' + (lightMode === true ? 'light' : '')"
  [formControl]="control"
  [items]="items"
  [multiple]="multiple"
  groupBy="category"
  bindLabel="displayValue"
  [selectableGroup]="false"
  [selectableGroupAsModel]="true"
  [closeOnSelect]="false"
  bindValue="id"
  [loading]="loading"
  [searchable]="searchable"
  [closeOnSelect]="closeOnSelect"
  [placeholder]="placeholder"
  [clearable]="clearable"
  [dropdownPosition]="dropdownPosition ? dropdownPosition : 'auto'"
  [ngClass]="{
    'disable-arrow disable-dropdown disable-clear-all': readonly === true
  }"
  (change)="onChange($event)"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-label" [title]="item.displayValue">{{ item.displayValue }}</span>
  </ng-template>
  <ng-template ng-header-tmp *ngIf="searchable == null ? false : searchable">
    <input
      style="width: 100%; line-height: 24px"
      type="text"
      placeholder="Search"
      (input)="select.filter($event.target.value)"
      [readonly]="readonly"
    />
  </ng-template>
  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="id">
    {{ item.category | uppercase }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="id">
    <span [title]="item.displayValue">{{ item.displayValue }}</span>
  </ng-template>
</ng-select>
